import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import React from 'react';
import {
  SupportSlotDefinitionPreviewDetailsTabState,
} from '../state/support-slot-definition-preview-details-tab-state';
import {UniversalInput} from '../../shared/UniversalInput';

type Props = {
  state: SupportSlotDefinitionPreviewDetailsTabState
  onDrawerClosed: () => void
  refreshSlotDefinitions: () => Promise<void>
}

export const SupportSlotDefinitionPreviewDetailsTab = ({state, onDrawerClosed, refreshSlotDefinitions}: Props) => {
  const buildStartTime = () => <UniversalInput
    label="Godzina rozpoczecia slotu"
    type="time"
    value={state.slotDefinition?.startTime}
    onChange={(val) => state.setSlotDefinition({...state.slotDefinition, startTime: val as string})}
    min={0}
    step={1}
  />

  const buildEndTime = () => <UniversalInput
    label="Godzina zakończenia slotu"
    type="time"
    value={state.slotDefinition?.endTime}
    onChange={(val) => state.setSlotDefinition({...state.slotDefinition, endTime: val as string})}
    min={0}
    step={1}
  />

  const buildValidFrom = () => <UniversalInput
    label="Aktywny od"
    type="date"
    value={state.slotDefinition?.validFrom}
    onChange={(val) => state.setSlotDefinition({...state.slotDefinition, validFrom: val as string})}
    min={0}
    step={1}
  />

  const buildValidTo = () => <UniversalInput
    label="Aktywny do"
    type="date"
    value={state.slotDefinition?.validTo}
    onChange={(val) => state.setSlotDefinition({...state.slotDefinition, validTo: val as string})}
    min={0}
    step={1}
  />

  return <form onSubmit={async (event) => {
    event.preventDefault();
    await state.onSlotDefinitionUpdated();
    await refreshSlotDefinitions();
  }}
  >
    <Stack spacing={3}>
      {buildStartTime()}
      {buildEndTime()}
      {buildValidFrom()}
      {buildValidTo()}
      <Button type="submit"
              variant="contained"
              color="primary"
      >
        Aktualizuj
      </Button>
      <Button variant="outlined"
              color="error"
              onClick={async () => {
                await state.onSlotDefinitionDeleted();
                await refreshSlotDefinitions();
                onDrawerClosed();
              }}
      >
        Usuń
      </Button>
    </Stack>
  </form>
}